import { Injectable } from '@angular/core';
import { IContributionMarginLevel } from '../models/contribution-margin-level.model';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';

const BASE_URL: string = 'contribution-margin-level';

@Injectable({
    providedIn: 'root'
})
export class ContributionMarginLevelResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getAllContributionMarginLevels(): Observable<IContributionMarginLevel[]> {
        return this.myCostAccountingRequestService.get(BASE_URL);
    }

    public addContributionMarginLevel(contributionMarginLevel: IContributionMarginLevel): Observable<IContributionMarginLevel>{
        return this.myCostAccountingRequestService.post(BASE_URL, contributionMarginLevel);
    }

    public updateContributionMarginLevel(contributionMarginLevel: IContributionMarginLevel): Observable<IContributionMarginLevel>{
        return this.myCostAccountingRequestService.put(`${BASE_URL}/${contributionMarginLevel.id}`, contributionMarginLevel);
    }

    public deleteContributionMarginLevel(contributionMarginLevelId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${contributionMarginLevelId}`);
    }
}
